import { render } from "./DxfInputContainer.vue?vue&type=template&id=19b6da3a"
import script from "./DxfInputContainer.vue?vue&type=script&lang=js"
export * from "./DxfInputContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__